import React from 'react';

const BakingClass = () => {
    return (
        <div className="banner_1 bg_image_2 jarallax">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="banner_content">
                            <img src="images/baking.png" alt="" />
                            <h3>Special Baking Class @Sunday 9.00am</h3>
                            <h6>
                                Famous Bakers from around the worls will take cooking
                                workshop. Si its an opportunity for you to join & learn
                                culnery Arts. And make delicious food in your kitchen
                            </h6>
                            <div className="button_group">
                                <a className="button">Join Baking Class</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BakingClass;